import { useRef, useState, useEffect } from "react";
import { Tooltip } from "antd";
import { renderCellHtml } from '../../../../../helpers/utils/safeHtml';
import css from './text.module.scss';

const extractHref = (html: string) => {
    const match = html.match(/href=['"]([^'"]+)['"]/);
    return match ? match[1] : null;
}

interface TextWithTooltipProps {
    text: string;
    maxWidth?: string | number;
}

export const TextWithTooltip = ({ text: initText, maxWidth }: TextWithTooltipProps) => {
    const text = String(initText)? String(initText)?.replace(/&nbsp;/g, ' ').replace(/\u00A0/g, ' ') : '';
    const title = text.includes('</a>') ? extractHref(text) ?? '' : text;
    
    const spanRef = useRef<HTMLSpanElement>(null);
    const [isTruncated, setIsTruncated] = useState(false);
    
    // Проверяем, обрезан ли текст
    useEffect(() => {
        const checkTruncation = () => {
            const el = spanRef.current;
            if (el) {
                // Проверяем горизонтальное переполнение или вертикальное (для многострочного)
                const isOverflowing = el.scrollWidth > el.clientWidth || el.scrollHeight > el.clientHeight;
                setIsTruncated(isOverflowing);
            }
        };
        
        checkTruncation();
        // Перепроверяем при изменении размера окна
        window.addEventListener('resize', checkTruncation);
        return () => window.removeEventListener('resize', checkTruncation);
    }, [text, maxWidth]);
    
    const style = maxWidth ? { '--text-max-width': typeof maxWidth === 'number' ? `${maxWidth}px` : maxWidth } as React.CSSProperties : undefined;
    
    // Показываем тултип только если текст обрезан
    return (
        <Tooltip title={isTruncated ? title : ''} placement="top">
            <span 
                ref={spanRef}
                className={css['text-container']} 
                style={style}
            >
                {renderCellHtml(text)}
            </span>
        </Tooltip>
    );
};